/* =============================================================================
=    Register for a new account
============================================================================= */
import { gql } from '@apollo/client';

export default gql`
mutation register($registerForm: RegisterFormInput!) {
  register(registerForm: $registerForm) {
    id
  }
}
`;
